import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('yotpoUgc'),
  titleToNamespace: true,
  hasConnectionStatus: false,
  avatarPath: avatars.yotpo,
  logoPath: logos.yotpo
});
